import {Input, Text} from '@priority-software/priority-style-react';
import React, {useEffect, useRef} from 'react';
import styles from './Input.module.scss';

type Props = Readonly<{
    autofocus?: boolean;
    label: string;
    onChange: (files: FileList | null) => void;
}>;

export default function FileInput({label, onChange, autofocus}: Props): JSX.Element {
    const inputRef = useRef(null);

    useEffect(() => {
        inputRef.current.accept = 'image/*';
    }, []);

    return (
        <div className={styles.component}>
            <Text tag="label" skin="label-1" componentClasses={styles.label}>
                {label}
            </Text>

            <Input
                size="large"
                inputRef={inputRef}
                autoFocus={autofocus}
                type="file"
                onChange={e => onChange(e.target.files)}
            />
        </div>
    );
}
